import React from 'react';
import people from '../../assets/people.webp';
import ai from '../../assets/ai.webp';
import './Header.css';

const Header = () => {
  return (
    <div id='home' className='header-container'>

      <div className='header-content'>
        <h1 className='gradient_text header-heading'>
          Lets Build Something <div>amazing with GPT-3</div> OpenAI
        </h1>
        <p className='header-subtext'>
          Yet bed any for travelling assistance indulgence unpleasing. 
          Not thoughts all exercise blessing. 
          Indulgence way everything joy alteration boisterous the attachment. 
          Party we years to order allow asked of.
        </p>
        <div className='header-form-container'>
          <form  className='header-form'>
            <input type="email" className='header-input-email' placeholder='Your Email Address' required />
            <button type="submit" className='header-submit-button'>Get Started</button>
          </form>
        </div>

        <div className='header-users-container'>
          <img src={people} alt='Users Logo' width={190} height={40} />
          <p>1,600 people requested access a visit in last 24 hours</p>
        </div>
      </div>

      <div className='header-image-container'>
        <img src={ai} alt="Header Logo" width={550} height={550} />
      </div>
    </div>
  )
}

export default Header